import React from "react";
import theme from "theme";
import { Theme, Image, LinkBox, Link, Box, Structure, Text, Section, Strong, Span, Em, Icon } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";
import { FaTelegram } from "react-icons/fa";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"prodvizhenie-internet-magazina-v-telegram"} />
		<Helmet>
			<title>
				Как продавать товары в Telegram
			</title>
			<meta name={"description"} content={"Продажи в Телеграм расскажем как правильно продвигать и продавать свои товары"} />
			<meta property={"og:title"} content={"Как продавать товары в Telegram"} />
			<meta property={"og:description"} content={"Продажи в Телеграм расскажем как правильно продвигать и продавать свои товары"} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/1.jpg?v=2022-12-25T20:50:47.139Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<meta name={"msapplication-TileColor"} content={"#000000"} />
		</Helmet>
		<Structure
			cells-number-total="2"
			quarkly-title="Navbar"
			position="relative"
			z-index="3"
			nout-z-index="9"
		>
			<Override
				slot="Content"
				grid-template-columns="3fr 1fr"
				nout-grid-template-columns="3fr 2fr"
				lg-grid-template-columns="1fr 1fr"
				md-grid-template-columns="1fr 2fr"
				sm-grid-template-columns="1fr"
				display="grid"
			>
				<Override slot="cell-0">
					<LinkBox href="/">
						<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z" display="block" />
					</LinkBox>
					<Components.QuarklycommunityKitMobileSidePanel menuPosition="right" breakpoint="nout">
						<Override
							slot="Content"
							background="rgba(255, 255, 255, 0)"
							md-background="--background"
							padding="8px 16px 8px 16px"
							nout-z-index="9999"
							nout-background="--background"
							justify-content="flex-start"
						/>
						<Override slot="Button Icon" size="32px" />
						<Override slot="Button Text" nout-text-transform="uppercase" nout-font="normal 500 16px/200% &quot;Montserrat&quot;, sans-serif" nout-letter-spacing="1px" />
						<Override slot="Wrapper" nout-z-index="9" />
						<Box
							width="100%"
							display="flex"
							grid-gap="32px"
							md-flex-direction="column"
							nout-flex-direction="column"
							nout-margin="20px 0px 0px 0px"
							nout-grid-gap="16px"
						>
							<Link
								href="/bot/instrukciya/#shop"
								color="#000000"
								font="--menu"
								text-decoration-line="initial"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Создание интернет-магазина
							</Link>
							<Link
								href="/bot/instrukciya/#bot"
								color="#000000"
								font="--menu"
								text-decoration-line="initial"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Подключение бота
							</Link>
							<Link
								href="/bot/instrukciya/#pay"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Онлайн оплата
							</Link>
							<Link
								href="/bot/instrukciya/#faq"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								FAQ
							</Link>
						</Box>
						<Box
							display="none"
							sm-display="flex"
							sm-flex-direction="column"
							sm-align-items="flex-start"
							sm-grid-gap="16px"
							sm-margin="16px 0px 0px 0px"
						>
							<Link
								href="/instrukciya"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Инструкция
							</Link>
							<Link
								href="https://t.me/uShopWebBot"
								color="--white"
								font="--button"
								text-decoration-line="initial"
								padding="12px 24px 12px 24px"
								background="--dark"
								border-radius="50px"
								transition="--opacityOut"
								hover-opacity=".8"
								target="_blank"
								md-padding="12px 20px 12px 20px"
								sm-align-self="center"
								sm-margin="20px 0px 0px 0px"
							>
								Создать веб-бота
							</Link>
						</Box>
					</Components.QuarklycommunityKitMobileSidePanel>
				</Override>
				<Override
					slot="Cell 0th"
					align-items="center"
					justify-content="flex-end"
					grid-gap="24px"
					display="flex"
					md-display="flex"
					md-grid-gap="16px"
				/>
				<Override slot="cell-1">
					<Components.ButtonBot />
				</Override>
				<Override slot="Cell 1" sm-display="none" />
			</Override>
		</Structure>
		<Section padding="140px 0 140px 0" background="linear-gradient(0deg,rgba(2, 2, 2, 0.58) 0%,rgba(2, 2, 2, 0.58) 99.5%),rgba(0, 0, 0, 0) url(https://images.unsplash.com/photo-1636743094110-5e153f93ad7e?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2000) center center/cover repeat scroll padding-box" sm-padding="120px 0 120px 0">
			<Override
				slot="SectionContent"
				align-items="flex-start"
				display="flex"
				grid-template-columns="2fr 1fr"
				grid-gap="16px"
			/>
			<Box
				min-width="100px"
				min-height="100px"
				md-display="flex"
				md-flex-direction="column"
				md-align-items="center"
			>
				<Text
					margin="0px 0px 0px 0px"
					font="--headline1"
					md-font="normal 800 32px/1.4 &quot;Montserrat&quot;, sans-serif"
					sm-font="normal 800 24px/1.4 &quot;Montserrat&quot;, sans-serif"
					color="--white"
					as="h1"
					md-text-align="center"
				>
					Способы продвижения интернет-магазина в Telegram{" "}
				</Text>
				<Text
					margin="8px 0px 48px 0px"
					font="--headline3"
					color="--white"
					as="h4"
					md-text-align="center"
				>
					В этой небольшой статье мы расскажем как правильно продавать и как продвигать свой магазин в Телеграм, при помощи создании своего каталога в виде веб-бота.{" "}
				</Text>
				<Link
					href="https://t.me/uSportClothes"
					color="--white"
					font="--button"
					text-decoration-line="initial"
					padding="16px 28px 16px 28px"
					background="--primary"
					border-radius="50px"
					transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
					hover-color="--dark"
					hover-background="--white"
					target="_blank"
					text-align="center"
				>
					Пример интернет-магазина в Telegram
				</Link>
			</Box>
		</Section>
		<Section padding="60px 0 60px 0" sm-padding="30px 0 30px 0" md-padding="30px 0 90px 0">
			<Text margin="0px 0px 24px 0px" font="--base">
				В прошлой статье мы разобрали такой вопрос, как: "
				<Link
					href="/dlya-chego-sozdat-magazin-v-Telegram/"
					color="--primary"
					text-decoration-line="initial"
					target="_blank"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					А нужен ли бизнесу интернет-магазин в Telegram
				</Link>
				", если вы все еще сомневаетесь, делать ли свой каталог в Телеграм, то рекомендуем эту статью к ознакомлению. В этой же статье мы поговорим о продвижении, не большой спойлер к статье: Продвижение и его способы раскрутки в Telegram практически такие же, как и в других социальных сетях.
			</Text>
			<Text
				id="shop"
				margin="0px 0px 14px 0px"
				font="--headline2"
				sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
				as="h2"
			>
				Продвижение магазина в Телеграм
			</Text>
			<Text margin="0px 0px 24px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				В настоящее время Telegram показывает очень высокий рост, обходя по росту новой аудитории все популярные мессенджеры и социальные сети. Большинство людей пользуется Телеграм, как для личного общения, так и для получение информации, именно так и начинали зарождаться большинство социальных сетей и только позже туда приходила коммерция (продажа товаров), которая только начинает зарождаться в Телеграм.
				<br />
				<br />
				{"\n"}Самыми популярные по продажам в Телеграм в данный момент являются: работа и образование (платное обучение, курсы), товары для авто, медицинские товары, мебель, товары для дома, инструменты, одежда и обувь. Размер среднего чека при осуществлении продаж через Телеграм, по оценке Admitad, вырос в 2022 году на 9,4% с 1986 до 2143 рублей
				<br />
				{"\n\n"}
			</Text>
			<Text margin="0px 0px 0px 0px" as="h3" font="--headline3">
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Способы раскрутки магазина:{" \n\n"}
				</Strong>
			</Text>
			<Text margin="0px 0px 24px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif">
				<Span
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Давайте разберем способы раскрутки нашего интернет-магазина, которого мы создали в формате веб-бота по{" "}
					<Link
						href="/instrukciya/"
						text-decoration-line="initial"
						color="--primary"
						target="_blank"
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						нашей инструкции
					</Link>
					.
					<br />
					<br />
				</Span>
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					1. Реклама в каналах.{" "}
				</Strong>
				Первый и самый популярный способ – это реклама в чатах и каналах. Каналы в Телеграм похожи по функционалу на группы во ВКонтакте. В таких каналах вы можете купить рекламный пост и разместить информацию о вашем магазине или о конкретном товаре, при чем вы можете установить{" "}
				<Link
					href="/delayem-magazin-v-Telegram/"
					target="_blank"
					text-decoration-line="initial"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					прямую ссылку на оплату товара
				</Link>
				. Подойдут каналы вашей товарной ниши или каналы с близкой целевой аудиторией по полу или возрасту. Выбрать каналы для покупки, вы можете при помощи сервиса{" "}
				<Link
					href="https://tgstat.ru/"
					target="_blank"
					text-decoration-line="initial"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					TGStat
				</Link>
				, он дает всю необходимую информацию, после выбора канала, вы просто связываетесь с администрацией этого канала и договариваетесь о размещении рекламы.
				<br />
				<br />
				Для покупки рекламы в каналах, вы также можете воспользоваться специальной биржей{" "}
				<Link
					target="_blank"
					href="https://telega.in/?r=e9DcVykI"
					text-decoration-line="initial"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Telega
				</Link>
				, но стоит учитывать что сервис берет комиссию за размещение рекламы и договариваться напрямую с администрацией дешевле!
				<br />
				<br />
				<Span
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					<Strong
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						Совет: старайтесь искать каналы, похожие по вашей тематике.
					</Strong>
					<Em
						overflow-wrap="normal"
						word-break="normal"
						white-space="normal"
						text-indent="0"
						text-overflow="clip"
						hyphens="manual"
						user-select="auto"
						pointer-events="auto"
					>
						{" "}
					</Em>
				</Span>
				То есть, если вы хотите привлечь определенную целевую аудиторию (автомобилистов, спортсменов или мамочек в декрете) - ищите каналы, где они обитают. В противном случае только деньги зря заплатите за рекламу, а результатов от рекламы не увидите. Проверить накручен канал или нет, можно{" "}
				<Link
					href="https://tgstat.ru/blog/tools-views-analyze-1002"
					color="--primary"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					по инструкции от TGStat
				</Link>
				<br />
				<br />
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					2. Реклама в ботах.
				</Strong>
				{" "}Помимо каналов рекламу могут размещать и чат-боты. Чат-боты это упрощенные вариации приложений, при чем ботов в Телеграм не чуть не меньше каналов и найти можно множество тематик от небольших ботов с ежедневными гороскопами до бирж криптовалют. Для подбора ботов, чтобы там приобрести рекламу, вы можете использовать сервис{" "}
				<Link
					href="https://botstat.io/"
					target="_blank"
					text-decoration-line="initial"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					BotStat
				</Link>
				.{" "}
				<br />
				<br />
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					3. Трафик из поиска Telegram.
				</Strong>
				{" "}Не стоит забывать, что в Телеграм есть свой внутренний поиск, в котором пользователи мессенджера могут напрямую найти вашего бота задав в поиске @username или искать "Спортивную одежду" через поиск и случайно наткнуться на ваш каталог в виде веб-бота. Но чтобы ваш бот находился выше других в поисковой выдачи вам нужно заполнить имя бота по ключевым словам, а также его About, Description и Botpic, которые устанавливаются в{" "}
				<Link
					href="https://t.me/BotFather"
					target="_blank"
					text-decoration-line="initial"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					@Botfather
				</Link>
				<br />
				<br />
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					4. Telegram Ads.{" "}
				</Strong>
				При помощи{" "}
				<Link
					href="https://ads.telegram.org/"
					target="_blank"
					color="--primary"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					TelegramAds{" "}
				</Link>
				можно настроить рекламу напрямую у конкурентов в их ботах или каналах. А также на любые{" "}
				<Link
					href="https://t.me/tginfo/4256"
					target="_blank"
					color="--primary"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					поисковые запросы
				</Link>
				. Как запустить эту рекламу, есть отдельная{" "}
				<Link
					href="https://t.me/WebBotChat/57286"
					target="_blank"
					color="--primary"
					hover-text-decoration-line="underline"
					text-decoration-line="initial"
				>
					инструкция
				</Link>
				{" "}в нашем чате-коммьюнити
				<br />
				<br />
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					5. Внешний трафик.
				</Strong>
				{" "}Тут все просто, это переходы ваших потенциальных покупателей с каких-либо каталог, статей или с вашего сайта. А возможно вы просто раздаете визитки с адресом бота своим постоянным покупателям. При чем можно рекламировать свой магазин через ТикТок, YouTube Shorts и пр., тем самым получая бесплатный трафик клиентов в свой магазин
				<br />
				<br />
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					6. Собственный канал.{" "}
				</Strong>
				Самый тяжелый, но и самый интересный способ увеличения продаж в Телеграм – это свой собственный канал.
				<br />
				Его оформление и введение мало чем отличается от ведения группы и сообществ в других социальных сетях. Так же надо размещать актуальные новости, поддерживать активность, создавать контент, который будет откликаться пользователю и стимулировать его совершать какие-то действия: покупать, спрашивать, участвовать в опросах, переходить в ваш бот, писать отзывы и т.д. в зависимости от специфики вашего бизнеса.
				<br />
				<br />
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					7. Оффлайн продвижение.{" "}
				</Strong>
				Если вы осуществляете доставку только по вашему городу, вы можете воспользоваться рекламой в региональных каналах и чатах вашего города (размещение рекламы в чатах больших ЖК вашего города)
				<br />
				{"\n\n\n\n"}
				<br />
				Для примера, если вы продаете коврики для йоги, вы можете создать канал про медитацию, писать о её пользе, возможно публиковать какие-то практики и пр., набив небольшую аудиторию на канале, вы сможете публиковать ссылку на покупку вашего товара, как это реализовано здесь:{" "}
				<Link
					href="https://t.me/uSportClothes"
					target="_blank"
					text-decoration-line="initial"
					color="--primary"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					@uSportClothes
					<br />
					<br />
				</Link>
				Как реализовать ссылками на товар, вы можете прочитать в этой{" "}
				<Link
					href="/onlayn-prodazha-tovarov-na-kanalakh-i-gruppakh/"
					color="--primary"
					text-decoration-line="initial"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
					target="_blank"
				>
					инструкции
				</Link>
			</Text>
		</Section>
		<Section background="--dark" padding="125px 0 125px 0" nout-padding="60px 0 60px 0" position="relative">
			<Override
				slot="SectionContent"
				display="flex"
				align-items="flex-start"
				md-align-items="center"
				md-justify-content="center"
				md-text-align="center"
			/>
			<Text
				margin="0px 0px 24px 0px"
				color="--white"
				font="--headline1"
				nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif"
				lg-font="normal 800 26px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-font="normal 800 22px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif"
				as="h2"
			>
				Заказать интернет-магазин в формате бота

в Telegram за 9800 руб.
			</Text>
			<Text
				margin="0px 0px 48px 0px"
				color="--white"
				font="--decsr"
				md-font="normal 500 16px/180% &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 500 14px/180% &quot;Montserrat&quot;, sans-serif"
			>
				Создание сайтов, магазинов, порталов и лендингов под ключ. Помощь по сайтам,
				<br />
				SEO-продвижение и консультации с вебмастерами.
			</Text>
			<Link
				href="https://bot.divly.pro/"
				color="--white"
				font="--button"
				text-decoration-line="initial"
				padding="16px 28px 16px 28px"
				background="--primary"
				border-radius="50px"
				transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
				hover-color="--dark"
				hover-background="--white"
				target="_blank"
			>
				Заказать веб-бот под ключ
			</Link>
		</Section>
		<Section
			background="--dark"
			padding="15px 0 15px 0"
			border-style="solid"
			border-color="--color-white"
			border-width="1px 0px 0px 0px"
			position="relative"
		>
			<Override
				slot="SectionContent"
				display="flex"
				align-items="center"
				flex-direction="row"
				grid-gap="16px"
				justify-content="space-between"
				md-flex-direction="column"
				md-align-items="center"
			/>
			<Box>
				<Text margin="0px 0px 0px 0px" color="--white" font="--base">
					<Link
						href="https://ukit.group/"
						color="--white"
						text-decoration-line="initial"
						target="_blank"
						hover-text-decoration-line="underline"
						padding="5px 5px 5px 5px"
					>
						© uKit Group
					</Link>
				</Text>
			</Box>
			<Box
				display="flex"
				grid-gap="32px"
				sm-flex-direction="column"
				sm-display="flex"
				sm-grid-gap="8px"
			>
				<Link
					href="https://www.ucoz.ru/details/"
					color="--white"
					font="--base"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					sm-text-align="center"
					padding="5px 5px 5px 5px"
				>
					Юридическая информация
					<Link href="https://www.ucoz.ru/details/" />
				</Link>
				<Link
					href="https://www.ucoz.ru/terms/"
					color="--white"
					font="--base"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					sm-text-align="center"
					padding="5px 5px 5px 5px"
				>
					Условия использования
				</Link>
			</Box>
			<LinkBox href="https://t.me/uShopWeb" target="_blank" transition="--opacityOut" hover-opacity="0.7">
				<Icon category="fa" icon={FaTelegram} size="24px" color="--white" />
			</LinkBox>
		</Section>
		<Components.EmbedHTML />
		<RawHtml>
			<style place={"endOfHead"} rawKey={"62ab65c921e43d0020961284"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n    scroll-behavior: smooth;\n}\nbody {\n    position: relative !important;\n}"}
			</style>
			<script place={"endOfBody"} rawKey={"639c57f598af799c2def4641"}>
				{"   (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};\n   m[i].l=1*new Date();\n   for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}\n   k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})\n   (window, document, \"script\", \"https://mc.yandex.ru/metrika/tag.js\", \"ym\");\n\n   ym(91719479, \"init\", {\n        clickmap:true,\n        trackLinks:true,\n        accurateTrackBounce:true,\n        webvisor:true\n   });"}
			</script>
			<script place={"endOfHead"} rawKey={"65b906fcebf1ff7fe82ff95a"}>
				{"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','GTM-59QRNH');"}
			</script>
			<script async={true} src={"//code.jivo.ru/widget/EsmX5tZp4R"} place={"endOfHead"} rawKey={"69b7f73f921c1a779c7c2cc6"} />
		</RawHtml>
	</Theme>;
});